var e = {
	accessRequests: {
		title: "Developer access requests",
		subtitle: "Host workspaces waiting on a developer-access verdict. Read-only here — accept, decline or revoke from the workspace's own Developer tab.",
		columns: {
			workspace: "Workspace",
			requested: "Requested"
		},
		empty: "No open developer-access requests.",
		loadFailed: "Couldn't load the developer-access queue.",
		retry: "Try again",
		previous: "Previous",
		next: "Next",
		pageStatus: "Showing {{from}}–{{to}} of {{total}}"
	},
	developerAccess: {
		title: "Developer access",
		loadFailed: "Couldn't load this workspace's developer access.",
		retry: "Try again",
		fields: {
			requested: "Requested",
			accepted: "Accepted",
			termsSigned: "Terms signed",
			sandbox: "Sandbox",
			keysIssued: "Keys issued",
			revoked: "Revoked",
			declineReason: "Decline reason",
			empty: "—"
		},
		actions: {
			accept: "Accept",
			decline: "Decline",
			revoke: "Revoke access",
			reinstate: "Reinstate access"
		},
		accept: {
			confirmTitle: "Accept this developer-access request?",
			confirmBody: "Creates a paired sandbox for this workspace. The host still has to sign the Developer Terms before any key can be issued.",
			success: "Developer access accepted",
			failed: "Could not accept the request"
		},
		reinstate: {
			confirmTitle: "Reinstate developer access?",
			confirmBody: "Lifts the revocation. A workspace that had signed the Developer Terms goes straight back to active and its keys start minting tokens again; one that had not returns to awaiting a signature.",
			success: "Developer access reinstated",
			failed: "Could not reinstate developer access"
		},
		keys: {
			title: "Developer keys",
			empty: "This workspace holds no developer keys.",
			loadFailed: "Couldn't load this workspace's developer keys.",
			rateLimitTooltip: "Rate limit — how many requests an hour this key may make",
			rateLimitDefault: "Service default",
			columns: {
				name: "Name",
				key: "Key",
				environment: "Environment",
				status: "Status",
				limit: "Rate limit",
				created: "Issued",
				lastUsed: "Last used"
			},
			status: {
				active: "Active",
				revoked: "Revoked",
				disabled: "Disabled",
				expired: "Expired"
			},
			environment: {
				sandbox: "Sandbox",
				production: "Production"
			}
		},
		rateLimit: {
			title: "Rate limit for {{name}}",
			intro: "How many requests an hour tokens minted from this key may make against the developer API. It takes effect on the key's next request. Leave it blank to use the service default.",
			label: "Requests per hour",
			placeholder: "Service default",
			hint: "Blank means the service default. A caller that exceeds the ceiling gets a 429 with a Retry-After header; nothing is revoked and no credential changes.",
			saved: "Updated {{name}}'s rate limit",
			failed: "Could not change the rate limit",
			cancel: "Cancel",
			save: "Save changes"
		},
		viewActivity: "View developer activity"
	},
	deliveries: {
		title: "Webhook deliveries",
		subtitle: "What we owe every developer's endpoint, what we sent, and what came back. Envelopes only — never the body.",
		filters: { allStatuses: "All statuses" },
		stats: {
			queued: "Queued",
			retrying: "Retrying",
			failed: "Failed",
			oldest: "Oldest outstanding",
			oldestNone: "Nothing outstanding"
		},
		redrive: {
			action: "Redrive",
			confirmTitle: "Redrive this delivery?",
			confirmBody: "It goes back in the queue and is attempted again from zero. Fix the endpoint first, or it will simply fail again.",
			done: "Back in the queue.",
			failed: "Could not redrive this delivery."
		},
		empty: {
			title: "No deliveries yet",
			body: "Nothing has been queued for a developer endpoint yet."
		},
		filtered: {
			title: "Nothing matched",
			body: "No delivery matches these filters. Clear them to see the whole log."
		},
		loadErrorTitle: "Couldn't load the deliveries",
		loadErrorBody: "The delivery log couldn't be read just now. Nothing is missing — try again.",
		detail: {
			title: "Delivery",
			emptyTitle: "Pick a delivery",
			emptyBody: "Its envelope, attempts and last error open here.",
			notLoadedTitle: "Not in the loaded list",
			notLoadedBody: "This delivery is further back than the rows loaded so far. Scroll the list to load it."
		}
	},
	requests: {
		title: "Developer API requests",
		subtitle: "Every request a developer key sent us. Search by the request id from an error response.",
		retry: "Try again",
		clearFilters: "Clear filters",
		detail: { filterDeveloper: "Show only this developer" }
	},
	platform: {
		title: "Developer platform",
		subtitle: "How the developer API is doing across every developer, and what is waiting on us.",
		traffic: "API requests, all developers",
		viewRequests: "View requests",
		unknownDeveloper: "Unknown developer",
		filters: {
			allDevelopers: "All developers",
			searchDevelopers: "Search developers",
			allEnvironments: "Any environment",
			bothEnvironments: "Both"
		},
		byDeveloper: {
			title: "Developers with the most errors",
			line: "{{failed}} failed of {{total}} · p95 {{p95}} ms",
			empty: "No developer is failing",
			emptyBody: "No developer key was answered with a 4xx or 5xx in this window."
		},
		queue: {
			failed: "Failed deliveries",
			inFlight: "{{retrying}} retrying · {{pending}} queued",
			view: "View",
			oldest: "Oldest undelivered"
		},
		access: {
			title: "Access requests waiting",
			review: "Review"
		}
	},
	directory: {
		title: "Developers",
		subtitle: "Every workspace that has asked for developer access, most recently active first.",
		searchPlaceholder: "Search by name or workspace",
		allStates: "Any state",
		keys_one: "{{count}} active key",
		keys_other: "{{count}} active keys",
		requests24h_one: "{{count}} request today",
		requests24h_other: "{{count}} requests today",
		failed24h_one: "{{count}} failed",
		failed24h_other: "{{count}} failed",
		neverCalled: "No calls yet",
		endpoint: {
			active: "Endpoint active",
			pending_verification: "Endpoint unverified",
			suspended: "Endpoint suspended"
		},
		loadErrorTitle: "Couldn't load the developers",
		loadErrorBody: "The directory couldn't be read just now. Nothing is missing — try again.",
		empty: {
			title: "No developers yet",
			body: "When a workspace asks for developer access, it appears here."
		},
		filtered: {
			title: "No developer matched",
			body: "Nothing matches that search or state. Clear the filters to see every developer."
		}
	},
	developerPage: {
		openWorkspace: "Open workspace",
		traffic: "API requests",
		viewLogs: "View logs",
		cancel: "Cancel",
		backToDevelopers: "Back to developers",
		loadErrorTitle: "Couldn't load this developer",
		loadErrorBody: "Their developer access couldn't be read just now. That says nothing about the workspace — try again.",
		notDeveloperTitle: "This workspace is not a developer",
		notDeveloperBody: "It has never asked for developer access, so there is no traffic or webhook to show.",
		tabs: {
			overview: "Overview",
			logs: "Logs",
			webhooks: "Webhooks"
		},
		summary: {
			requests24h: "Requests, last 24 hours",
			errorRate24h: "Error rate, last 24 hours",
			p95: "p95, last 24 hours",
			failedDeliveries: "Failed deliveries",
			view: "View"
		},
		details: {
			title: "Details",
			state: "Access",
			slug: "Handle",
			openSandbox: "Open sandbox workspace",
			keys: "Keys",
			manageKeys_one: "{{count}} key · manage",
			manageKeys_other: "{{count}} keys · manage"
		},
		endpoint: {
			title: "Webhook endpoint",
			none: "No endpoint registered",
			noneBody: "This developer has not registered an endpoint in this environment.",
			unsigned: "Webhook signing is not configured, so nothing can be delivered or rotated here."
		},
		actions: {
			more: "More actions",
			sendTest: "Send test event",
			rotate: "Rotate signing secret",
			copyId: "Copy developer id",
			idCopied: "Developer id copied"
		},
		testEvent: {
			title: "Send a test event",
			body: "Queues one real delivery of a sample event to the developer's endpoint, signed and badged test. It counts against your own daily allowance for this developer, never theirs.",
			environment: "Environment",
			event: "Event",
			send: "Send test event",
			success: "Test event queued",
			remaining_one: "You can send {{count}} more to this developer today.",
			remaining_other: "You can send {{count}} more to this developer today.",
			error: "Couldn't send the test event"
		},
		rotate: {
			title: "Rotate signing secret",
			body: "Mints the endpoint's next signing secret. The current one keeps signing alongside it for the overlap window, so the developer's running code still verifies. The rotation is recorded under your name.",
			environment: "Endpoint",
			confirm: "Rotate secret",
			error: "Couldn't rotate the secret",
			secretWarning: "This is the only time this secret is shown. The previous secret stops signing on {{date}}.",
			secretHint: "Hand it to the developer through a secure channel. It is not stored anywhere we can read it back from.",
			done: "I've handed it over"
		}
	}
};
//#endregion
export { e as default };
